import React from "react";
import { Target, Eye, Award, Rocket } from "lucide-react";
import SEO from "../components/SEO";
import "./About.css";

const About = () => {
  return (
    <div className="about-container">
      <SEO 
        title="About Us | Vektrixo Digital Pune" 
        description="Learn about the Vektrixo Digital journey. We are a Pune-based multidisciplinary team bridging technical complexity and business growth through premium software engineering, QA automation, and business consulting."
        keywords="Vektrixo Digital About, Software Engineering Pune, Tech Agency India, Core Values, Quality Assurance Team, Business Scale Pune"
        canonical="https://www.vektrixo.com/about"
      />
      {/* Vision Header */}
      <section className="about-header">
        <span className="badge">Established 2026</span>
        <h1>
          Driven by <span className="highlight">Innovation</span>, Focused on
          Results
        </h1>
        <p>
          Vektrixo Digital was founded to bridge the gap between technical
          complexity and business growth.
        </p>
      </section>

      {/* Our Story Section */}
      <section className="story-section">
        <div className="story-content">
          <h2>
            The <span className="highlight">Vektrixo</span> Journey
          </h2>
          <p>
            Starting from a deep expertise in Web Engineering and Quality Assurance, Vektrixo Digital has evolved into a trusted tech partner. Now operating from Pune, we help businesses build fast, reliable, and high-converting digital products.
          </p>

          <div className="mission-vision-grid">
            <div className="mv-card">
              <div className="mv-icon"><Target size={20} color="#38bdf8" /></div>
              <div>
                <h3>Our Mission</h3>
                <p>To provide high-quality web development and testing solutions that solve real business challenges and drive growth.</p>
              </div>
            </div>
            <div className="mv-card">
              <div className="mv-icon"><Eye size={20} color="#38bdf8" /></div>
              <div>
                <h3>Our Vision</h3>
                <p>To build a world-class technology consultancy known for engineering excellence, transparency, and reliable execution.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="story-image">
          <div className="image-wrapper">
            <div className="box-decoration"></div>
            <div className="main-image-box">
              <img src="/mission.png" alt="Vektrixo Mission" />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="about-stats-strip">
        <div className="about-stat-item">
          <h3>10+</h3>
          <p>Global Clients</p>
        </div>
        <div className="about-stat-item">
          <h3>15+</h3>
          <p>Projects Delivered</p>
        </div>
        <div className="about-stat-item">
          <h3>200+</h3>
          <p>Bugs Identified</p>
        </div>
        <div className="about-stat-item">
          <h3>99%</h3>
          <p>Success Rate</p>
        </div>
      </section>

      {/* Core Values (Grid) */}
      <section className="values-section">
        <h2 className="section-title">
          Our Core <span className="highlight">Values</span>
        </h2>
        <div className="values-grid">
          <div className="value-card">
            <Target className="value-icon" size={32} />
            <h3>Precision</h3>
            <p>
              From QA to Design, every pixel and every line of code is tested
              for absolute accuracy.
            </p>
          </div>
          <div className="value-card">
            <Rocket className="value-icon" size={32} />
            <h3>Scalability</h3>
            <p>
              We build systems and strategies that grow with your business, not
              against it.
            </p>
          </div>
          <div className="value-card">
            <Eye className="value-icon" size={32} />
            <h3>Transparency</h3>
            <p>
              No jargon. No hidden costs. Just clear communication and
              measurable outcomes.
            </p>
          </div>
          <div className="value-card">
            <Award className="value-icon" size={32} />
            <h3>Excellence</h3>
            <p>
              We don't settle for "good enough." We aim for industry-defining
              standards.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
